<template>
    <form-view class="map-service-detail-view">
        <template slot="field">
            <h3>基本信息</h3>
            <veui-field label="geotableId：">
                <veui-span>{{ store.serviceDetail.geotableId }}</veui-span>
            </veui-field>
            <veui-field label="应用名称：">
                <veui-span>{{ store.serviceDetail.appName }}</veui-span>
            </veui-field>
            <veui-field label="服务名称：">
                <veui-span>{{ store.serviceDetail.name }}</veui-span>
            </veui-field>
            <veui-field label="所属行业：">
                <veui-span>{{ store.serviceDetail.firstLevelIndustry }}，</veui-span>
                <veui-span>{{ store.serviceDetail.secondLevelIndustry }}</veui-span>
            </veui-field>
            <veui-field label="是否同步到地图：">
                <veui-span>{{ store.yesAndNoMap[store.serviceDetail.sync] }}</veui-span>
            </veui-field>
            <h3 v-if="isAdmin">领券奖项</h3>
            <veui-table :data="store.storeListInfo.result || []" v-if="isAdmin">
                <veui-table-column title="门店编号" field="id">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.id }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="门店名称" field="title">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.title }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="省" field="province">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.province }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="市" field="city">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.city }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="详细地址" field="address">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.address }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column v-for="field in store.customFields"
                    :key="field.identify"
                    :title="field.name"
                    :field="field.identify">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props[field.identify] }}</p>
                    </template>
                    </veui-table-column>
            </veui-table>
            <veui-pagination v-if="isAdmin" class="map-store-list-pagination"
                :page="store.storeListInfo.pageNo"
                :page-size="store.storeListInfo.pageSize"
                :total="store.storeListInfo.totalCount"
                :page-sizes="store.pageSizes"
                @redirect="pageNoChange"
                ui="full"
                native
                @pagesizechange="pageSizeChange"/>
        </template>
        <template slot="operation">
            <veui-button v-if="!isAdmin" @click="goToFieldDetail" ui="primary">查看门店字段</veui-button>
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import DetailModel from './DetailModel';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Table, Span, Column, Pagination} from 'veui';
import serviceMixin from '@/common/mixins/service';
import mapMixin from './mixin';

export default createView(FormView, DetailModel, {
    name: 'MapServiceDetailView',
    components: {
        'veui-field': Field,
        'veui-table': Table,
        'veui-span': Span,
        'veui-button': Button,
        'veui-steps': Steps,
        'veui-pagination': Pagination,
        'veui-table-column': Column
    },
    mixins: [serviceMixin, mapMixin],
    created() {
        if (this.isAdmin) {
            this.store.requestStoreList();
        }
    },
    computed: {
        isAdmin() {
            return this.store.isAdmin;
        }
    },
    methods: {
        pageSizeChange(pageSize) {
            this.store.storeListInfo.pageSize = pageSize;
            this.store.storeListInfo.pageNo = 1;
            this.store.requestStoreList({pageSize});
        },
        pageNoChange(page, event) {
            event.preventDefault();
            this.store.storeListInfo.pageNo = page;
            this.store.requestStoreList({pageNo: page});
        },
        goToFieldDetail() {
            let prefix = this.isAdmin ? '' : '/app';
            let serviceId = this.store.getRouteParams().serviceId;
            this.global.redirect({url: `${prefix}/service/${serviceId}/map/store/detail`, type: 'push'});
        }
    }
});
</script>

<style lang="less">
.map-service-detail-view {
    .veui-form-label {
        width: 130px;
    }
    .map-store-list-pagination {
        float: right;
        margin-top: 20px;
    }
}
</style>
